const nutritionGoals = [
  {
    label: "PCOS",
    value: 3,
  },
  {
    label: "Prenatal Care",
    value: 9,
  },
  {
    label: "Postnatal Care",
    value: 6,
  },
  {
    label: "Wellness",
    value: 1,
  },
  {
    label: "Thyroid Management",
    value: 4,
  },
  {
    label: "Hypertension Management",
    value: 7,
  },
  {
    label: "Diabetes Management",
    value: 5,
  },
  {
    label: "Gut Health Management",
    value: 8,
  },
  {
    label: "High Cholesterol",
    value: 47,
  },
  {
    label: "High Uric Acid",
    value: 48,
  },
];

export default nutritionGoals;

// const nutritionGoalList = [
//   {
//     label: "PCOS",
//     value: "pcos",
//     slug: "nutrition-callback-pcos-d",
//     ranking: 0,
//     related_nutrition_goals: ["PCOS", "PCOS & Infertility"],
//     related_nutrition_goals_ids: [3, 15],
//     is_customer_goal: false,
//   },
//   {
//     label: "Prenatal Care",
//     value: "prenatal",
//     slug: "nutrition-callback-prenatal",
//     ranking: 0,
//     related_nutrition_goals: ["Pre Natal"],
//     related_nutrition_goals_ids: [9],
//     is_customer_goal: false,
//   },
//   {
//     label: "Postnatal Care",
//     value: "postnatal",
//     slug: "nutrition-callback-pre-postnatal",
//     ranking: 0,
//     related_nutrition_goals: ["Post Natal"],
//     related_nutrition_goals_ids: [6],
//     is_customer_goal: false,
//   },
//   {
//     label: "Wellness",
//     value: "wellness",
//     slug: "nutrition-callback-wellness",
//     ranking: 0,
//     related_nutrition_goals: ["General"],
//     related_nutrition_goals_ids: [1],
//     is_customer_goal: false,
//   },
//   {
//     label: "Thyroid Management",
//     value: "thyroid",
//     slug: "nutrition-callback-thyroid",
//     ranking: 0,
//     related_nutrition_goals: ["Thyroid Disorders"],
//     related_nutrition_goals_ids: [4],
//     is_customer_goal: false,
//   },
//   {
//     label: "Hypertension Management",
//     value: "hypertension",
//     slug: "nutrition-callback-highbp",
//     ranking: 0,
//     related_nutrition_goals: ["High Blood Pressure", "Hypertension"],
//     related_nutrition_goals_ids: [7, 17],
//     is_customer_goal: false,
//   },
//   {
//     label: "Diabetes Management",
//     value: "diabetes",
//     slug: "nutrition-callback-diabetes",
//     ranking: 0,
//     related_nutrition_goals: ["Diabetes"],
//     related_nutrition_goals_ids: [5],
//     is_customer_goal: false,
//   },
//   {
//     label: "Gut Health Management",
//     value: "gut-health",
//     slug: "nutrition-callback-guthealth",
//     ranking: 0,
//     related_nutrition_goals: ["Gut Health"],
//     related_nutrition_goals_ids: [8],
//     is_customer_goal: false,
//   },
// ];
